module.exports = __webpack_public_path__ + "img/logo_grupo_merca.69d7112c.png";